<template>
  <v-alert
    v-if="quota"
    :type="quota.level"
    :prominent="prominent"
    :dense="dense"
    :text="text"
    :class="alertClass"
  >
    {{ quota.message }}
    <template v-if="appendActions" v-slot:append>
      <quota-actions
        :full="quota.full"
        @compare="$emit('compare')"
        @manage="$emit('manage')"
      />
    </template>
    <quota-actions
      v-else
      :full="quota.full"
      @compare="$emit('compare')"
      @manage="$emit('manage')"
    />
  </v-alert>
</template>

<script>
import IngestionQuotaActions from "@/components/IngestionQuotaActions.vue";

export default {
  name: "IngestionQuotaAlert",
  components: {
    QuotaActions: IngestionQuotaActions
  },
  props: {
    quota: { type: Object, default: null },
    prominent: Boolean,
    dense: Boolean,
    text: Boolean,
    appendActions: Boolean,
    alertClass: { type: [String, Array, Object], default: "" }
  }
};
</script>
